import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './ProgressBar.module.css';

const MIN_PROGRESS_WIDTH = 2.73;

interface ProgressBarProps {
    progressWidth?: number;
    isExhaustedLimit?: boolean;
    isDisabledLimit?: boolean;
}

export const ProgressBar = ({ progressWidth, isExhaustedLimit, isDisabledLimit }: ProgressBarProps) => (
    <div className={styles.track}>
        <div
            className={clsx(styles.line, isDisabledLimit ? styles.disabled : isExhaustedLimit && styles.exhausted)}
            style={progressWidth === undefined ? undefined : { width: `${Math.max(progressWidth, MIN_PROGRESS_WIDTH)}%` }}
        />
    </div>
);

ProgressBar.propTypes = {
    isExhaustedLimit: PropTypes.bool,
    isDisabledLimit: PropTypes.bool,
    progressWidth: PropTypes.number,
};
